export default "/_next/static/images/793900fde76cb50fd2ed578ece7f8037.jpg";